import React from 'react'
import { MessageDescriptor } from 'react-intl'

export enum CommonToolkitSectionName {
  HEADER = 'header',
  FOOTER = 'footer',
}

export enum CENTER_OF_EXCELLENCE {
  NEURODIVERSITY = 'neurodiversity',
  HEALTH_CHALLENGES = 'health-challenges',
  WOMENS_HEALTH = 'womens-health',
  MANAGER_HUB = 'manager-hub',
  PEDIATRICS = 'pediatrics',
}

export enum NeurodiversitySearcherType {
  ADULT = 'adult',
  CHILD = 'child',
  TEEN = 'teen',
}

export enum PediatricsAgeGroup {
  CHILD = 'child',
  TEEN = 'teen',
  YOUNG_ADULT = 'youngAdult',
}

export enum PediatricsContactCarePathway {
  BHUC = 'bhuc',
  VIOP = 'viop',
}

export enum NeurodiversityToolkitHeaderVariant {
  ADULT_PLUS_CHILD = 'ADULT_PLUS_CHILD',
  ADULT_ONLY = 'ADULT_ONLY',
  TEEN = 'TEEN',
}

export enum CENTER_OF_EXCELLENCE_PAGE {
  LANDING_PAGE = 'LANDING_PAGE',
  CARE_OPTIONS = 'CARE_OPTIONS',
}

export type CenterOfExcellenceSearcherTypeToCareMetadata = {
  [key in NeurodiversitySearcherType]?: {
    cards: CenterOfExcellenceCareOptionCardConfig[]
  }
}

export type CenterOfExcellencePageToMetadata = {
  [CENTER_OF_EXCELLENCE_PAGE.CARE_OPTIONS]?: CenterOfExcellenceSearcherTypeToCareMetadata
  [CENTER_OF_EXCELLENCE_PAGE.LANDING_PAGE]?: undefined
}

export enum TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC {
  WOMENS_MENTAL_HEALTH_PREGNANCY = 'womens-mental-health-pregnancy',
  WOMENS_MENTAL_HEALTH_FERTILITY_ISSUES = 'womens-mental-health-fertility-issues',
  WOMENS_MENTAL_HEALTH_MENOPAUSE = 'womens-mental-health-menopause',
  WOMENS_MENTAL_HEALTH_PREMENSTRUAL_SYNDROME = 'womens-mental-health-premenstrual-syndrome',
  WOMENS_MENTAL_HEALTH_MENTAL_LOAD = 'womens-mental-health-mental-load',
  WOMENS_MENTAL_HEALTH_SELF_ESTEEM = 'womens-mental-health-self-esteem',
  WOMENS_MENTAL_HEALTH_CAREGIVING = 'womens-mental-health-caregiving',
  WOMENS_MENTAL_HEALTH_OTHER_WOMENS_MENTAL_HEALTH_ISSUES = 'womens-mental-health-other-womens-mental-health-issues',
  HEALTH_CHALLENGES_BODY_IMAGE_ISSUES = 'health-challenges-body-image-issues',
  HEALTH_CHALLENGES_CHRONIC_PAIN = 'health-challenges-chronic-pain',
  HEALTH_CHALLENGES_CANCER_SURVIVORSHIP = 'health-challenges-cancer-survivorship',
  HEALTH_CHALLENGES_SLEEP_ISSUES = 'health-challenges-sleep-issues',
  HEALTH_CHALLENGES_OTHER_CHRONIC_HEALTH_CONDITIONS = 'health-challenges-other-chronic-health-conditions',
  NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION = 'neurodiversity-neuropsychological-evaluation',
  NEURODIVERSITY_TREATMENT_FOR_AUTISM = 'neurodiversity-treatment-for-autism',
  NEURODIVERSITY_TREATMENT_FOR_ADHD = 'neurodiversity-treatment-for-adhd',
  NEURODIVERSITY_OTHER_NEURODIVERSITY_TOPICS = 'neurodiversity-other-neurodiversity-topics',
  NEURODIVERSITY_NEUROPSYCHOLOGICAL_EVALUATION_CHILD = 'neurodiversity-neuropsychological-evaluation-child',
  NEURODIVERSITY_CAREGIVER_TRAINING_FOR_NEURODIVERSE_CHILD = 'neurodiversity-caregiver-training-for-neurodiverse-child',
  NEURODIVERSITY_TREATMENT_FOR_AUTISM_CHILD = 'neurodiversity-treatment-for-autism-child',
  NEURODIVERSITY_TREATMENT_FOR_ADHD_CHILD = 'neurodiversity-treatment-for-adhd-child',
  NEURODIVERSITY_OTHER_NEURODIVERSITY_TOPICS_CHILD = 'neurodiversity-other-neurodiversity-topics-child',
}

export type CenterOfExcellenceCareOptionCardConfig = {
  id: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC
  title: MessageDescriptor
  modalTitle: MessageDescriptor
  modalDescription: MessageDescriptor
  shouldShow: boolean
  getIcon: (size: number) => React.ReactElement
  onModalConfirmPress?: () => void
}

export interface NeurodiversityCareOptionCardsParams {
  navigateToSelfSearchForCare: (subTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => void
  navigateToChildSearchForCare: (subTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => void
}

export type NeurodiversitySearcherInfo = {
  searcherType: NeurodiversitySearcherType
  contactCareNavEntryPoint?: NeurodiversityContactCareNavigatorEntryPoint
  childId?: string
  toolkitSubTopic?: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC
}

export enum NeurodiversityContactCareNavigatorEntryPoint {
  NEURODIVERSITY_NAVIGATION = 'Neurodiversity Navigation',
  SELECTED_CARE_OPTION = 'Selected Care Option',
  CHILD_SEARCH_FOR_CARE = 'Child Search For Care',
}

export interface HealthChallengesCareOptionCardsParams {
  navigateToSearchForCare: (subTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => void
}

export interface WomensHealthCareOptionCardsParams {
  navigateToSearchForCare: (subTopic: TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC) => void
}
